var CoreTwilioServiceClient = (function () {
    function CoreTwilioServiceClient(service) {
        this.service = service;
    }
    CoreTwilioServiceClient.prototype.sendMessage = function (to, from, body, mediaUrl) {
        var args = {
            body: body,
            from: from,
            to: to
        };
        if (mediaUrl !== undefined) {
            args.mediaUrl = mediaUrl;
        }
        return this.service.callFunction("send", [args]);
    };
    return CoreTwilioServiceClient;
}());
export default CoreTwilioServiceClient;
//# sourceMappingURL=CoreTwilioServiceClient.js.map